// Shared public contract. A missing collection is bootstrap; an explicit invalid
// collection fails closed to Portfolio, never to the full shipped defaults.
export const PROJECTS_TABS = [
  ["project_tab_portfolio", "portfolio", "Projects", "Project portfolio and status.", true],
  ["project_tab_weekly", "weekly", "Updates", "Weekly project updates.", true],
  ["project_tab_gantt", "gantt", "Timeline", "Project timeline and milestones.", true],
  ["project_tab_financials", "financials", "Financials", "Project budgets and spend. Existing sensitivity permissions apply.", true],
  ["projects_risk_register", "risk-register", "Risks", "Curated project risks.", false],
  ["project_tab_participants", "participants", "Participants", "Project participants. Editing remains admin-only.", true],
  ["project_tab_signals", "signals", "Signals", "Signals - coming soon.", true],
  ["project_tab_contracts", "contracts", "Contracts", "Contracts - coming soon.", false],
].map(([key, lens, label, description, enabled], sort_order) => ({
  key, lens, label, description, enabled, sort_order,
  locked: lens === "portfolio",
}));
export const DEFAULT_PROJECTS_TABS = PROJECTS_TABS.map((row) => ({ ...row }));
// Presentation only: never rewrite stored governance or its admin ordering.
export const PROJECTS_CANONICAL_ORDER = [
  "portfolio", "weekly", "gantt", "financials", "risk-register", "contracts", "participants",
];
export function projectsPresentationTabs(value) {
  const rank = (lens) => {
    const index = PROJECTS_CANONICAL_ORDER.indexOf(lens);
    return index < 0 ? PROJECTS_CANONICAL_ORDER.length : index;
  };
  return [...normalizeProjectsTabs(value)].sort((a, b) => rank(a.lens) - rank(b.lens));
}
export function normalizeProjectsTabs(value, diagnose = () => {}) {
  if (value === undefined) return DEFAULT_PROJECTS_TABS;
  const seen = new Set();
  let invalid = !Array.isArray(value) || value.length === 0;
  const rows = (Array.isArray(value) ? value : []).flatMap((row) => {
    const def = PROJECTS_TABS.find((item) => item.key === row?.key);
    if (!def || seen.has(row.key) || typeof row.enabled !== "boolean"
      || !Number.isInteger(row.sort_order) || row.sort_order < 0) {
      invalid = true;
      return [];
    }
    seen.add(row.key);
    if (def.locked && !row.enabled) invalid = true;
    return [{ ...def, enabled: def.locked || row.enabled, sort_order: row.sort_order }];
  });
  if (!seen.has("project_tab_portfolio")) {
    invalid = true;
    rows.push({ ...PROJECTS_TABS[0] });
  }
  if (rows.length !== PROJECTS_TABS.length) invalid = true;
  if (invalid) diagnose("Invalid Projects tab configuration - normalized to safe recognized rows.");
  return rows.sort((a, b) => a.sort_order - b.sort_order || a.key.localeCompare(b.key));
}
